import type { FilterableMenuItem } from 'owa-filterable-menu';
import type { AssetDescriptor } from 'owa-timestream-asset-sdk-types';
import { lazyGetCreateAssetMenuItems } from 'owa-calendar-board-commanding';

export function getCreateAssetMenuItem(
    assets: AssetDescriptor[],
    config: {
        isShowAllAssetsExpanded: boolean;
        onShowAllAssetsToggled: (
            event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
        ) => void;
    }
): FilterableMenuItem {
    const getCreateAssetMenuItem = lazyGetCreateAssetMenuItems.tryImportForRender();

    return getCreateAssetMenuItem
        ? getCreateAssetMenuItem(assets, {
              isShowAllAssetsExpanded: config.isShowAllAssetsExpanded,
              onShowAllAssetsToggled: config.onShowAllAssetsToggled,
              overflowCount: 5, // show 4 assets + 1 overflow button
          })
        : null;
}
